import { getOpenInNewTabContextMenuItem } from './utils/getOpenInNewTabContextMenuItem';
import {
    COMPOSE_ONLY_ATTACHMENT_CONTENT_END,
    COMPOSE_ONLY_ATTACHMENT_CONTENT_START,
} from './utils/constants';

export {
    COMPOSE_ONLY_ATTACHMENT_CONTENT_END,
    COMPOSE_ONLY_ATTACHMENT_CONTENT_START,
    getOpenInNewTabContextMenuItem,
};
